<div
  class="mb-[28px] flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between"
  [ngClass]="toolbarClass"
>
  <div class="flex min-w-0 flex-1 flex-col gap-3 sm:flex-row sm:items-center">
    <ng-content select="[toolbar-left]"></ng-content>
  </div>

  <div class="flex shrink-0 items-center justify-end gap-2">
    <ng-content select="[toolbar-right]"></ng-content>
  </div>
</div>
